// extracted by mini-css-extract-plugin
export default {"Filters":"AccreditationsFilters_Filters__hrIgv"};